// extracted by mini-css-extract-plugin
export default {"root":"ImageSettings_root__hnMg8","resetButtonWrapper":"ImageSettings_resetButtonWrapper__hHuwW","upsellMessage":"ImageSettings_upsellMessage__lA9bv"};